<template>
  <div>
    <v-progress-linear
      v-if="carregandoPregao"
      indeterminate
      color="primary"
      class="mb-2"
    />

    <v-form @submit.prevent="salvarPregao">
      <v-row class="custoB d-flex space-between ma-5">
        <v-col cols="12" sm="12" md="4">
          <v-autocomplete
            v-model="dadosPregao.nomeOrgao"
            :items="orgaosCadastrados"
            auto-select-first
            dense
            chips
            clearable
            deletable-chips
            :disabled="carregandoPregao"
            label="Nome do Órgão"
          >
            <template v-slot:label>
              <strong>Nome do Órgão</strong>
              <v-icon style="vertical-align: middle">apartment</v-icon>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="dadosPregao.idPregao"
            outlined
            hint="Código do pregão"
            :disabled="carregandoPregao"
          >
            <template v-slot:label>
              <strong>ID do Pregão</strong>
              <v-icon style="vertical-align: middle">mdi-key-variant</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-btn
            type="button"
            block
            x-large
            color="primary"
            :loading="salvandoPregao"
            :disabled="carregandoPregao"
            @click="salvarPregao"
            v-on:dblclick.prevent
          >
            <v-icon left>mdi-clipboard-check-outline</v-icon>
            {{ textoBotaoSalvar }}
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            origin="center center"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dataInicialFormatada"
                outlined
                label="DATA INICIAL"
                hint="Data inicial do pregão"
                persistent-hint
                append-icon="mdi-calendar"
                readonly
                :disabled="carregandoPregao"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dadosPregao.dataInicial"
              :active-picker.sync="activePicker"
              min="1950-01-01"
              @change="dateSave"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            origin="center center"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dataFinalFormatada"
                outlined
                label="DATA FINAL"
                hint="Data final do pregão"
                persistent-hint
                append-icon="mdi-calendar"
                readonly
                :disabled="carregandoPregao"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dadosPregao.dataFinal"
              :active-picker.sync="activePicker2"
              min="1950-01-01"
              @change="dateSave2"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="12" md="2">
          <v-text-field v-model="dadosPregao.pneNi" outlined :disabled="carregandoPregao">
            <template v-slot:label>
              <strong>PNE NI</strong>
              <v-icon style="vertical-align: middle">mdi-folder-key-network-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="2">
          <v-text-field v-model="dadosPregao.pneHs" outlined :disabled="carregandoPregao">
            <template v-slot:label>
              <strong>PNE HS</strong>
              <v-icon style="vertical-align: middle">mdi-folder-key-network-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col v-if="modoEdicao" cols="12" sm="12" md="4">
          <div class="c-arquivado-toggle pa-4 rounded-lg">
            <v-switch
              v-model="dadosPregao.arquivado"
              color="#733634"
              inset
              :disabled="carregandoPregao"
              :label="dadosPregao.arquivado ? 'Pregão Arquivado' : 'Pregão Ativo'"
            />
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-divider class="mb-4" />
          <div class="d-flex align-center justify-space-between flex-wrap mb-3">
            <div class="d-flex align-center mr-4 mb-2 mb-sm-0">
              <v-icon color="primary" class="mr-2">mdi-format-list-numbered</v-icon>
              <span class="text-h6 font-weight-bold">Itens da Licitação</span>
            </div>
            <v-btn type="button" color="#943634" dark :disabled="carregandoPregao" @click="abrirModalNovoItemPregao">
              <v-icon left>mdi-plus</v-icon>
              Adicionar item
            </v-btn>
          </div>
          <itensPregao
            ref="itensPregaoRef"
            :key="itensPregaoKey"
            :produtosCadastrados="produtosCadastrados"
            :itensIniciais="itensPregaoIniciais"
            :modoEdicao="modoEdicao"
            @change="atualizarItensPregao"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-dialog v-model="dialogConfirmarSaida" max-width="430px">
      <v-card>
        <v-card-title class="text-h6">Sair sem salvar?</v-card-title>
        <v-card-text>
          Existem alteracoes nao salvas nesta edicao. Deseja fechar a tela e descartar essas mudancas?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmarSaida = false">Continuar editando</v-btn>
          <v-btn color="error" text @click="confirmarFechamento">Sair sem salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import barramento from "@/barramento";
import { urlApi, showError } from "@/global";
import itensPregao from "./itensPregao";

const novoPregaoPadrao = () => ({
  nomeOrgao: "",
  idPregao: "",
  dataInicial: "",
  dataFinal: "",
  pneNi: "",
  pneHs: "",
  arquivado: false,
  notificaoNf: null,
});

export default {
  name: "cadastroPregao",
  components: { itensPregao },
  props: {
    orgaosCadastrados: { type: Array, default: () => [] },
    produtosCadastrados: { type: Array, default: () => [] },
    modoEdicao: { type: Boolean, default: false },
    pregaoId: { type: [Number, String], default: null },
  },
  data: () => ({
    dadosPregao: novoPregaoPadrao(),
    itensPregaoDraft: [],
    itensPregaoIniciais: [],
    itensPregaoKey: 0,
    activePicker: null,
    activePicker2: null,
    menu: false,
    menu2: false,
    salvandoPregao: false,
    carregandoPregao: false,
    dialogConfirmarSaida: false,
    estadoInicialSerializado: "",
  }),
  computed: {
    textoBotaoSalvar() {
      return this.modoEdicao ? "SALVAR ALTERAÇÕES" : "SALVAR PREGÃO";
    },
    textoAjudaSalvar() {
      return this.modoEdicao
        ? "As alterações do cabeçalho e dos itens serão persistidas ao salvar."
        : "Os dados e itens só serão persistidos ao salvar.";
    },
    textoAjudaItens() {
      return this.modoEdicao
        ? "Itens com empenho ficam destacados e bloqueados para edição."
        : "Monte os itens abaixo e salve tudo de uma vez.";
    },
    dataInicialFormatada() {
      return this.formatarDataParaExibicao(this.dadosPregao.dataInicial);
    },
    dataFinalFormatada() {
      return this.formatarDataParaExibicao(this.dadosPregao.dataFinal);
    },
    temAlteracoesPendentes() {
      if (this.carregandoPregao) return false;

      return this.gerarSnapshotEstado() !== this.estadoInicialSerializado;
    },
    textoAjudaItensSeguro() {
      return this.modoEdicao
        ? "Itens com empenho ficam destacados, nao podem ser removidos e so permitem alterar o valor de compra."
        : "Monte os itens abaixo e salve tudo de uma vez.";
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "Ano"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "Ano"));
    },
    pregaoId: {
      immediate: true,
      handler(id) {
        if (this.modoEdicao && id) {
          this.carregarDadosEdicao(id);
        }
      },
    },
  },
  methods: {
    abrirModalNovoItemPregao() {
      if (this.$refs.itensPregaoRef && typeof this.$refs.itensPregaoRef.abrirModalNovoItem === "function") {
        this.$refs.itensPregaoRef.abrirModalNovoItem();
      }
    },

    normalizarDataEntrada(valor) {
      if (!valor) return "";

      if (typeof valor === "string") {
        const valorLimpo = valor.trim();

        if (/^\d{4}-\d{2}-\d{2}/.test(valorLimpo)) {
          return valorLimpo.slice(0, 10);
        }

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(valorLimpo)) {
          const [dia, mes, ano] = valorLimpo.split("/");
          return `${ano}-${mes}-${dia}`;
        }
      }

      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) {
        return "";
      }

      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    formatarDataParaExibicao(valor) {
      const dataNormalizada = this.normalizarDataEntrada(valor);
      if (!dataNormalizada) return "";

      const [ano, mes, dia] = dataNormalizada.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    serializarTipoUnidade(tipoUnidade) {
      return tipoUnidade;
    },

    gerarSnapshotEstado() {
      const itensNormalizados = this.itensPregaoDraft
        .map((item) => ({
          id: item.id || null,
          uid: item.uid || null,
          produto_id: Number(item.produto_id) || null,
          idGenericaProduto: String(item.idGenericaProduto || ""),
          descricao_edital: item.descricao_edital || "",
          quantidadeProdutoPregao: Number(item.quantidadeProdutoPregao) || 0,
          valorProdutoPregao: Number(item.valorProdutoPregao) || 0,
          valorDeCompra: Number(item.valorDeCompra) || 0,
          tipoUnidade: this.serializarTipoUnidade(item.tipoUnidade),
        }))
        .sort((itemA, itemB) => {
          const chaveA = `${itemA.id || ""}-${itemA.uid || ""}`;
          const chaveB = `${itemB.id || ""}-${itemB.uid || ""}`;
          return chaveA.localeCompare(chaveB, "pt-BR", { numeric: true, sensitivity: "base" });
        });

      return JSON.stringify({
        nomeOrgao: this.dadosPregao.nomeOrgao || "",
        idPregao: this.dadosPregao.idPregao || "",
        dataInicial: this.normalizarDataEntrada(this.dadosPregao.dataInicial),
        dataFinal: this.normalizarDataEntrada(this.dadosPregao.dataFinal),
        pneNi: this.dadosPregao.pneNi || "",
        pneHs: this.dadosPregao.pneHs || "",
        arquivado: !!this.dadosPregao.arquivado,
        notificaoNf: this.dadosPregao.notificaoNf || null,
        itens: itensNormalizados,
      });
    },

    registrarEstadoInicial() {
      this.estadoInicialSerializado = this.gerarSnapshotEstado();
    },

    atualizarItensPregao(itens) {
      this.itensPregaoDraft = itens;
    },

    mapearItensEdicao(itens) {
      return itens.map((item) => ({
        id: item.id,
        uid: `item-${item.id}`,
        produto_id: item.produto_id,
        name: item.name,
        imageUrl: item.imageUrl,
        idGenericaProduto: String(item.numero_item || ""),
        descricao_edital: item.descricao_edital || "",
        quantidadeProdutoPregao: Number(item.quantidade) || 0,
        valorProdutoPregao: Number(item.valor_unitario_venda) || 0,
        valorDeCompra: Number(item.valor_unitario_compra) || 0,
        tipoUnidade: item.tipoUnidade !== undefined ? item.tipoUnidade : item.tipo_unidade,
        bloqueadoEdicao: !!item.bloqueadoEdicao,
        quantidade_empenhada: Number(item.quantidade_empenhada || item.quantidades_empenhadas) || 0,
        quantidade_restante: Number(item.quantidade_restante) || 0,
      }));
    },

    async carregarDadosEdicao(id) {
      this.carregandoPregao = true;

      try {
        const [pregaoRes, itensRes] = await Promise.all([
          axios.get(`${urlApi}/pregao/${id}`),
          axios.get(`${urlApi}/pregao/${id}/item`),
        ]);

        const pregao = pregaoRes.data || {};
        this.dadosPregao = {
          nomeOrgao: pregao.nomeOrgao || "",
          idPregao: pregao.idPregao || "",
          dataInicial: this.normalizarDataEntrada(pregao.dataInicial),
          dataFinal: this.normalizarDataEntrada(pregao.dataFinal),
          pneNi: pregao.pneNi || "",
          pneHs: pregao.pneHs || "",
          arquivado: !!pregao.arquivado,
          notificaoNf: pregao.notificaoNf,
        };

        this.itensPregaoIniciais = this.mapearItensEdicao((itensRes && itensRes.data) || []);
        this.itensPregaoDraft = this.itensPregaoIniciais.map((item) => ({ ...item }));
        this.itensPregaoKey += 1;
        this.$nextTick(() => this.registrarEstadoInicial());
      } catch (err) {
        showError(err);
      } finally {
        this.carregandoPregao = false;
      }
    },

    limparForm() {
      this.dadosPregao = novoPregaoPadrao();
      this.itensPregaoDraft = [];
      this.itensPregaoIniciais = [];
      this.itensPregaoKey += 1;
      this.activePicker = null;
      this.activePicker2 = null;
      this.menu = false;
      this.menu2 = false;
      this.salvandoPregao = false;
      this.carregandoPregao = false;
      this.dialogConfirmarSaida = false;
      this.estadoInicialSerializado = "";
    },

    dateSave(date) {
      this.dadosPregao.dataInicial = this.normalizarDataEntrada(date);
      this.$refs.menu.save(this.dadosPregao.dataInicial);
    },

    dateSave2(date) {
      this.dadosPregao.dataFinal = this.normalizarDataEntrada(date);
      this.$refs.menu2.save(this.dadosPregao.dataFinal);
    },

    validarCabecalho() {
      if (
        !this.dadosPregao.nomeOrgao ||
        !this.dadosPregao.idPregao ||
        !this.dadosPregao.dataInicial ||
        !this.dadosPregao.dataFinal
      ) {
        showError("Preencha os campos obrigatórios do pregão antes de salvar.");
        return false;
      }

      return true;
    },

    validarItens() {
      if (!this.itensPregaoDraft.length) {
        showError("Adicione ao menos um item à licitação antes de salvar o pregão.");
        return false;
      }

      const itemInvalido = this.itensPregaoDraft.find((item) => (
        !item.produto_id ||
        !item.idGenericaProduto ||
        !item.quantidadeProdutoPregao ||
        item.quantidadeProdutoPregao <= 0 ||
        !item.valorProdutoPregao ||
        item.valorProdutoPregao <= 0
      ));

      if (itemInvalido) {
        showError(
          `Preencha quantidade e valor de venda do item ${itemInvalido.idGenericaProduto} antes de salvar o pregão.`
        );
        return false;
      }

      return true;
    },

    montarPayload() {
      return {
        ...this.dadosPregao,
        dataInicial: this.normalizarDataEntrada(this.dadosPregao.dataInicial),
        dataFinal: this.normalizarDataEntrada(this.dadosPregao.dataFinal),
        listaProdutos: this.itensPregaoDraft.map((item) => ({
          id: item.id || null,
          produto_id: item.produto_id,
          idGenericaProduto: String(item.idGenericaProduto),
          name: item.name,
          imageUrl: item.imageUrl,
          descricao_edital: item.descricao_edital || "",
          valorDeCompra: Number(item.valorDeCompra) || 0,
          valorProdutoPregao: Number(item.valorProdutoPregao) || 0,
          quantidadeProdutoPregao: Number(item.quantidadeProdutoPregao) || 0,
          tipoUnidade: this.serializarTipoUnidade(item.tipoUnidade),
        })),
      };
    },

    solicitarFechamento() {
      if (this.temAlteracoesPendentes) {
        this.dialogConfirmarSaida = true;
        return;
      }

      this.fecharModal();
    },

    confirmarFechamento() {
      this.dialogConfirmarSaida = false;
      this.fecharModal();
    },

    salvarPregao() {
      if (!this.validarCabecalho() || !this.validarItens()) {
        return;
      }

      this.salvandoPregao = true;

      let payload = null;

      try {
        payload = this.montarPayload();
      } catch (err) {
        this.salvandoPregao = false;
        showError(err);
        return;
      }

      const requisicao = this.modoEdicao
        ? axios.put(`${urlApi}/pregao/${this.pregaoId}`, payload)
        : axios.post(`${urlApi}/pregao`, payload);

      requisicao
        .then(() => {
          this.registrarEstadoInicial();
          barramento.EnviarLoadPregao(true);
          this.$toasted.global.defaultSuccess({
            msg: this.modoEdicao
              ? "Pregão atualizado com sucesso!"
              : "Pregão cadastrado com sucesso!",
          });
          this.fecharModal();
        })
        .catch(showError)
        .finally(() => {
          this.salvandoPregao = false;
        });
    },

    fecharModal() {
      this.limparForm();
      this.$emit("fechar");
    },
  },
  mounted() {
    if (!this.modoEdicao) {
      this.registrarEstadoInicial();
    }
  },
};
</script>

<style>
.form-pregao__item {
  font-family: "Georama", sans-serif !important;
}

.c-arquivado-toggle {
  background: #e6e6e6;
}
</style>
